module.exports = __webpack_public_path__ + "img/default-blog-cover.63243145.png";